export const GUEST_HOUSES = [
  { id: 1, name: 'LD Guest House',         shortName: 'LD',  description: 'Premier accommodation on the BHU main campus with modern amenities and easy access to all facilities.',       totalRooms: 50 },
  { id: 2, name: 'Faculty Guest House',    shortName: 'FG',  description: 'Exclusive stays for faculty, visiting professors, and official delegations of Banaras Hindu University.',     totalRooms: 50 },
  { id: 3, name: 'SSB Guest House',        shortName: 'SSB', description: 'Comfortable accommodation for researchers, scholars, and conference attendees in a serene environment.',       totalRooms: 50 },
  { id: 4, name: 'University Guest House', shortName: 'UG',  description: 'Central BHU accommodation serving all categories of visitors, guests, and official delegations.',             totalRooms: 50 },
];

const ROOM_CONFIGS = [
  { type: 'Single',    capacity: 1, basePrice: 600,  isAC: false },
  { type: 'Double',    capacity: 2, basePrice: 1000, isAC: false },
  { type: 'AC Single', capacity: 1, basePrice: 1200, isAC: true  },
  { type: 'AC Double', capacity: 2, basePrice: 1800, isAC: true  },
  { type: 'Suite',     capacity: 3, basePrice: 2500, isAC: true  },
];

function generateRooms() {
  const rooms = [];
  let id = 1;
  GUEST_HOUSES.forEach((gh, ghIdx) => {
    const blockStart = (ghIdx + 1) * 100;
    for (let i = 0; i < 12; i++) {
      const cfg = ROOM_CONFIGS[i % ROOM_CONFIGS.length];
      rooms.push({
        id,
        guestHouseId:   gh.id,
        guestHouseName: gh.name,
        roomNumber:     String(blockStart + i + 1),
        roomType:       cfg.type,
        capacity:       cfg.capacity,
        pricePerNight:  cfg.basePrice + ghIdx * 100,
        status:         'available',
        isAC:           cfg.isAC,
      });
      id++;
    }
  });
  return rooms;
}

export const ROOMS_SEED = generateRooms();

function d(offset) {
  const dt = new Date();
  dt.setDate(dt.getDate() + offset);
  return dt.toISOString().slice(0, 10);
}

export const BOOKINGS_SEED = [];
